"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAppContext = createAppContext;
exports.AppContextProvider = AppContextProvider;
const UserClient_1 = require("@juvare/platform-sdk-js/UserClient");
const react_1 = __importDefault(require("react"));
/**
 * @deprecated
 */
function createAppContext() {
    const initialContext = {
        initState: noop,
        invalidateState: noopPromise,
    };
    return react_1.default.createContext(initialContext);
}
/**
 * @deprecated
 */
function AppContextProvider(props) {
    const [response, setResponse] = react_1.default.useState();
    const AppContext = props.appContext;
    const value = {
        currentUser: response,
        userState: response?.state,
        switchUserPrev: response?.switchUserPrev,
        initState: setResponse,
        invalidateState: () => {
            return new UserClient_1.UserClient().invalidateUserState().then((newResponse) => {
                if (JSON.stringify(newResponse) !== JSON.stringify(response)) {
                    setResponse(newResponse);
                }
                return newResponse.state;
            });
        },
    };
    return react_1.default.createElement(AppContext.Provider, { value: value }, props.children);
}
const noop = () => undefined;
const noopPromise = () => Promise.reject();
